import React from 'react';
import styles from './index.module.scss';
import { IEventsList } from '../';
import classNames from 'classnames';
import ContentBox from './ContentBox';

export default function TimelineContent({ events }: { events: IEventsList[] }) {
  return (
    <div className={classNames(styles.root, 'flex flex-col')}>
      {events.map((event, index) => (
        <ContentBox event={event} key={`${event.name}-${index}`} />
      ))}
    </div>
  );
}
